import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  apiError: null,
  rateLimitExpiry: null,
};

export const ApiDataSlice = createSlice({
  name: "apiData",
  initialState,
  reducers: {
    setApiData: (state, action) => {
      const { key, data } = action.payload;
      state[key] = data;
    },
    setApiError: (state, action) => {
      state.apiError = action.payload;
    },
    setRateLimitExpiry: (state, action) => {
      // Use the Retry-After expiry from the latest 429 response.
      state.rateLimitExpiry = action.payload;
    },
    clearRateLimit: (state, action) => {
      if (state.rateLimitExpiry === action.payload) {
        state.rateLimitExpiry = null;
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const { clearRateLimit, setApiData, setApiError, setRateLimitExpiry } = ApiDataSlice.actions;

export default ApiDataSlice.reducer;
